"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EccentricSponsor = void 0;
var CardName_1 = require("../../CardName");
var PreludeCard_1 = require("./PreludeCard");
var PlayProjectCard_1 = require("../../deferredActions/PlayProjectCard");
var CardRenderer_1 = require("../render/CardRenderer");
var Size_1 = require("../render/Size");
var EccentricSponsor = (function (_super) {
    __extends(EccentricSponsor, _super);
    function EccentricSponsor() {
        return _super.call(this, {
            name: CardName_1.CardName.ECCENTRIC_SPONSOR,
            metadata: {
                cardNumber: 'P11',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.text('Play a card from hand, reducing its cost by 25 M€', Size_1.Size.SMALL, true);
                }),
            },
        }) || this;
    }
    EccentricSponsor.prototype.getCardDiscount = function (player) {
        if (player.lastCardPlayed === this.name) {
            return 25;
        }
        return 0;
    };
    EccentricSponsor.prototype.play = function (player) {
        player.game.defer(new PlayProjectCard_1.PlayProjectCard(player));
        return undefined;
    };
    return EccentricSponsor;
}(PreludeCard_1.PreludeCard));
exports.EccentricSponsor = EccentricSponsor;
